/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/auth/auth.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AuthGuardService } from "./auth-guard.service";
import { User } from "./user";
import * as i0 from "@angular/core";
/** @type {?} */
export const userFactory = (/**
 * @return {?}
 */
() => User.fromBody());
export class AuthModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: AuthModule,
            providers: [
                AuthGuardService,
                { provide: User, useFactory: userFactory },
            ],
        };
    }
}
AuthModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    RouterModule,
                ],
            },] },
];
/** @nocollapse */ AuthModule.ɵmod = i0.ɵɵdefineNgModule({ type: AuthModule });
/** @nocollapse */ AuthModule.ɵinj = i0.ɵɵdefineInjector({ factory: function AuthModule_Factory(t) { return new (t || AuthModule)(); }, imports: [[
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AuthModule, { imports: [RouterModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    RouterModule,
                ],
            }]
    }], null, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aC5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9hdXRoL2F1dGgubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFzQixRQUFRLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFDNUQsT0FBTyxFQUFDLFlBQVksRUFBQyxNQUFNLGlCQUFpQixDQUFDO0FBRTdDLE9BQU8sRUFBQyxnQkFBZ0IsRUFBQyxNQUFNLHNCQUFzQixDQUFDO0FBQ3RELE9BQU8sRUFBQyxJQUFJLEVBQUMsTUFBTSxRQUFRLENBQUM7OztBQUU1QixNQUFNLE9BQU8sV0FBVzs7O0FBQUcsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFBO0FBT2hELE1BQU0sT0FBTyxVQUFVOzs7O0lBQ2QsTUFBTSxDQUFDLE9BQU87UUFDbkIsT0FBTztZQUNMLFFBQVEsRUFBRyxVQUFVO1lBQ3JCLFNBQVMsRUFBRztnQkFDVixnQkFBZ0I7Z0JBQ2hCLEVBQUMsT0FBTyxFQUFHLElBQUksRUFBRSxVQUFVLEVBQUcsV0FBVyxFQUFDO2FBQzNDO1NBQ0YsQ0FBQztJQUNKLENBQUM7OztZQWRGLFFBQVEsU0FBQztnQkFDUixPQUFPLEVBQUc7b0JBQ1IsWUFBWTtpQkFDYjthQUNGOzs4Q0FDWSxVQUFVO21HQUFWLFVBQVUsa0JBSlg7WUFDUixZQUFZO1NBQ2I7d0ZBRVUsVUFBVSxjQUhuQixZQUFZO2tEQUdILFVBQVU7Y0FMdEIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixZQUFZO2lCQUNiO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge01vZHVsZVdpdGhQcm92aWRlcnMsIE5nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtSb3V0ZXJNb2R1bGV9IGZyb20gXCJAYW5ndWxhci9yb3V0ZXJcIjtcblxuaW1wb3J0IHtBdXRoR3VhcmRTZXJ2aWNlfSBmcm9tIFwiLi9hdXRoLWd1YXJkLnNlcnZpY2VcIjtcbmltcG9ydCB7VXNlcn0gZnJvbSBcIi4vdXNlclwiO1xuXG5leHBvcnQgY29uc3QgdXNlckZhY3RvcnkgPSAoKSA9PiBVc2VyLmZyb21Cb2R5KCk7XG5cbkBOZ01vZHVsZSh7XG4gIGltcG9ydHMgOiBbXG4gICAgUm91dGVyTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBBdXRoTW9kdWxlIHtcbiAgcHVibGljIHN0YXRpYyBmb3JSb290KCk6IE1vZHVsZVdpdGhQcm92aWRlcnMge1xuICAgIHJldHVybiB7XG4gICAgICBuZ01vZHVsZSA6IEF1dGhNb2R1bGUsXG4gICAgICBwcm92aWRlcnMgOiBbXG4gICAgICAgIEF1dGhHdWFyZFNlcnZpY2UsXG4gICAgICAgIHtwcm92aWRlIDogVXNlciwgdXNlRmFjdG9yeSA6IHVzZXJGYWN0b3J5fSxcbiAgICAgIF0sXG4gICAgfTtcbiAgfVxufVxuIl19